import React from 'react';
import { Space, Tag } from 'antd';
import Button from '../Button';

export type ActiveFilterChip = {
  /** 고유 키 — 같은 필드의 칩이 여러 개면 값까지 섞어 만든다 */
  key: string;
  label: string;
  /** 주면 칩에 X 가 붙어 이 조건만 뺄 수 있다 */
  onRemove?: () => void;
};

type ActiveFiltersProps = {
  chips: ActiveFilterChip[];
  onClearAll?: () => void;
};

/**
 * 적용된 필터 칩 (AMZUWEB-684).
 *
 * 검색 박스는 접히거나 스크롤 밖으로 나가는데 표는 남는다. 그때
 * *"왜 3건밖에 안 나오지"* 의 답이 화면 어디에도 없으면 사람은 데이터를 의심한다.
 * 지금 걸린 조건을 표 바로 위에 항상 보여 준다.
 *
 * URL 로 들어온 링크에서 특히 중요하다 — 남이 보낸 링크를 연 사람은
 * 어떤 조건이 걸려 있는지 모른 채 표부터 본다.
 */
export const ActiveFilters = ({ chips, onClearAll }: ActiveFiltersProps): React.JSX.Element | null => {
  if (chips.length === 0) {
    return null;
  }

  return (
    <Space size={[4, 8]} wrap={true}>
      {chips.map((chip) => (
        <Tag key={chip.key} closable={Boolean(chip.onRemove)} onClose={chip.onRemove}>
          {chip.label}
        </Tag>
      ))}
      {onClearAll && <Button color="light" text="전체 초기화" onClick={onClearAll} />}
    </Space>
  );
};
